import React from 'react';
import PropTypes from 'prop-types';
import { DatePickerFilterTemplate } from 'themes/components';

const DatePickerFilter = function(props) {
    return <DatePickerFilterTemplate {...props} />
};

DatePickerFilterTemplate.propTypes = {
    queryUtility: PropTypes.object,
    propertyName: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    clearVisible: PropTypes.bool
};

export default DatePickerFilter;
